module.exports = __webpack_public_path__ + "static/media/ic-error.63d8fc1e.svg";